// import { sleep } from '@/util'
import $store from '@/store'

export default {
  name: 'system',
  namespaced: true,
  state: {
    status: false,
    routerStatusRedirect: true,
  },
  mutations: {
    setStatus(state, status) {
      state.status = status
    },
    setRouterStatusRedirect(state, routerStatusRedirect) {
      state.routerStatusRedirect = routerStatusRedirect
    },
  },
  actions: {
    async init({ commit }, status = true) {
      await $store.dispatch('auth/init')
      await $store.dispatch('myfinbiz/init', location.host)
      commit('setStatus', status)

      // setTimeout(() => {
      //   commit('setStatus', status)
      //   console.log('init success!')
      // }, 500)
    },
  },
}

window.setRouterStatusRedirect = (v) => {
  $store.commit('system/setRouterStatusRedirect', v)
}
